module.exports = __webpack_public_path__ + "static/media/arborea7.e2e07dff.webp";